import { createContext } from 'react';

import { UserState } from './user.model';

export const UserContext = createContext<undefined | UserState>(undefined);

UserContext.displayName = 'UserContext';
